const PostBehaviourJS = function() {
  this.$display = $('[data-display]');
}
PostBehaviourJS.prototype.get_device_type = function() {
  const ua = navigator.userAgent;
  // 1. Check for specific Tablet user agents
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  // 2. Check for iPadOS tablets masking as desktop (Macintosh + Touch)
  const isIPadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(ua);
  if (isIPadOS) {
    return "tablet";
  }
  // 3. Check for Mobile user agents
  const isMobileUA = /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua);
  if (isMobileUA) {
    return "mobile";
  }
  // 4. Fallback check for touch screens under a certain width
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
  if (isTouchDevice && window.innerWidth <= 1024) {
    return window.innerWidth <= 768 ? "mobile" : "tablet";
  }
  return "desktop";
}
PostBehaviourJS.prototype.is_mobile_device = function() {
  return $(window).innerWidth <= 1024;
}
PostBehaviourJS.prototype.is_desktop = function() {
  return this.get_device_type() == 'desktop';
}
PostBehaviourJS.prototype.display = function() {
  if (this.is_desktop()) {
    this.$display.find('[data-meta]').hide();
    this.$display.on('mouseenter', function (e) {
      $(this).find('[data-meta]').show('slow');
    }).on('mouseleave', function (e) {
      $(this).find('[data-meta]').hide('slow');
    });
  }
  else {
    this.$display.find('[data-meta]').show();
  }
};
const PostBehaviour = new PostBehaviourJS();
PostBehaviour.display();

$(window).on('resize',function(){
  PostBehaviour.display();
});
